import Link from "next/link"
import { useQuery } from "react-apollo"

import Head from "../../../components/head-data/head-data"
import RequestSignIn from "../../../components/request-sign-in/request-sign-in"
import FounderPage from "../../../components/founder-page/founder-page"
import { PROFILE_PAGE_QUERY } from "../../../components/founder-page/queries"
import { displayName, generatedHeadline, resolveCover } from "../../../components/founder-page/lib"

// Link previews: the photo on the profile's cover color, 1200x630
const shareImage = (user) => {
  const pic = user.profilePic || ""
  if (!/res\.cloudinary\.com\/.+\/image\/upload\//.test(pic)) return undefined
  const cover = resolveCover(user)
  const bg = (cover.color || "#E7E5E4").replace("#", "")
  return pic.replace("/image/upload/", `/image/upload/w_630,h_630,c_fill,g_face/c_pad,w_1200,h_630,b_rgb:${bg}/f_jpg,q_auto/`)
}

const Unavailable = () => (
  <div className="fp">
    <div className="fp-inner fp-unavailable">
      <h1 className="fp-h2">This profile isn't available</h1>
      <p className="fp-prose fp-muted">The account may have been closed.</p>
      <Link href="/find-a-co-founder">
        <a className="fp-btn">Find a co-founder</a>
      </Link>
    </div>
  </div>
)

const Loading = () => (
  <div className="fp" aria-busy="true">
    <div className="fp-inner">
      <div className="fp-cover fp-skel" />
    </div>
  </div>
)

const ProfileView = ({ id, me }) => {
  const owner = Boolean(me && me.id === id)
  const { data, loading, error } = useQuery(PROFILE_PAGE_QUERY, {
    variables: { id, loggedInUserId: me ? me.id : null },
  })
  const url = `https://www.foundercloud.com/profile/${id}`

  if (loading && !(data && data.user)) return <Loading />
  if ((error || !data || !data.user) && !owner) {
    return (
      <>
        <Head title="Profile not available" description="Profile not available" url={url} noIndex />
        <Unavailable />
      </>
    )
  }

  // the owner's own fields come from `me`, which every edit updates
  const base = (data && data.user) || {}
  const user = owner ? { ...base, ...me, nestAnswers: base.nestAnswers || [], addedBy: [] } : base
  const name = displayName(user.firstName)
  const description = user.headline || generatedHeadline(user) || `${name} on FounderCloud`

  return (
    <>
      <Head title={`${name} on FounderCloud`} description={description} url={url} ogImage={shareImage(user)} noIndex />
      <FounderPage user={user} me={me} owner={owner} />
    </>
  )
}

const ProfilePage = ({ query, me }) => {
  const id = (query && query.id) || (me && me.id)
  if (!id) return <RequestSignIn />
  return <ProfileView id={id} me={me} />
}

export default ProfilePage
